module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__officeBanking_Min.b0845f4f.svg";